export default {
  name: 'ModalWindow',

  props: {
    borderType: {
      type: String,
      default: 'normal',
    },
  },

  methods: {
    show() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
  },

  data() {
    return {
      isVisible: false,
    };
  },
};
